//natives
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

//components
import Table from "../../../../../../util/Table/.mixins/Table";
import Error from "../../../../../../util/error/.mixins/Error";
import ListaVazia from "../../../../../../util/listaVazia/.mixins/ListaVazia";

//css
import GrupoOpcoesCss from "./GrupoOpcoesCss";
const useStyles = GrupoOpcoesCss();

export default function GrupoOpcoes(props) {
    const classes = useStyles();
    return (
        <div className="container">
            <br />
            {props.state.isLoading && (
                <div align="center">
                    <CircularProgress />
                </div>
            )}
            {!props.state.isLoading && props.state.itensTable.length <= 0 && !props.state.isError && (
                <div>
                    <ListaVazia
                        text={props.state.ListaVaziaTitle}
                        textDescription={props.state.ListaVaziaText}
                    />
                </div>
            )}
            {!props.state.isLoading && !props.state.isError && (
                <Table {...props} className={classes.root} />
            )}
            {props.state.isError && (
                <div align="center">
                    <Error text={props.state.error} />
                </div>
            )}
        </div>
    );
}
